import { ColumnDefinition } from '@approvalmax/ui/src/components/Table/Table.types';
import { getPath, Path } from 'urlBuilder';

import { Row } from '../../OffboardUserPopupContent.types';
import LinkCell from '../LinkCell/LinkCell';
import ReplacementCell from '../ReplacementCell/ReplacementCell';
import WarningCell from '../WarningCell/WarningCell';
import { messages } from './ApprovalWorkflows.messages';
import { ApprovalWorkflowsColumnsIds } from './ApprovalWorkflows.types';

export const ApprovalWorkflowsColumns: ColumnDefinition<Row>[] = [
    {
        id: ApprovalWorkflowsColumnsIds.WorkflowName.toString(),
        name: messages.nameColumn,
        value: (item) => <LinkCell name={item.name} link={getPath(Path.workflow, item.companyId, item.workflowId)} />,
        spacing: '16 8',
    },
    {
        id: ApprovalWorkflowsColumnsIds.Step.toString(),
        name: messages.stepColumn,
    },
    {
        id: ApprovalWorkflowsColumnsIds.Role.toString(),
        name: messages.roleColumn,
    },
    {
        id: ApprovalWorkflowsColumnsIds.Replacement.toString(),
        name: messages.replacementColumn,
        value: (item) => <ReplacementCell item={item} />,
        width: 250,
        spacing: '0 8',
    },
    {
        id: ApprovalWorkflowsColumnsIds.Warning.toString(),
        value: (item) => <WarningCell item={item} />,
        width: 50,
    },
];
